import { useMutation } from "@tanstack/react-query";
import { api, queryClient } from "../../context";

interface ClearRequestResponse {
  message: string;
}

export const clearRequestFn = (requestId: string) => {
  return api<ClearRequestResponse>({
    method: "POST",
    url: `/requests/${requestId}/clear`,
  });
};

export const useClearRequest = () => {
  return useMutation({
    mutationFn: ({ requestId }: { requestId: string }) =>
      clearRequestFn(requestId),
    onSuccess: (_, { requestId }) => {
      queryClient.invalidateQueries({ queryKey: ["request", requestId] });
      queryClient.invalidateQueries({ queryKey: ["requests"] });
    },
    onError: (error) => {
      console.error("Error clearing request: ", error);
      throw error;
    },
  });
};
